import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MessageType from '../../../../enums/MessageType';
import {hidePudoCollectionPoints} from '../../../actions/pudo-actions';
import Translation from '../../../lang/Translation';
import PudoNewCollectionPointLazyLoader from '../../pudo/PudoCollectionPoint/PudoNewCollectionPointLazyLoader';
import Message from '../../ui/Message/Message';
import CheckoutOverlay from '../CheckoutOverlay';

export function PudoOverlay(props) {
  const shouldNotLoadPUDO = document.documentMode !== undefined;
  
  const getInfoMessage = () => (
    <Message type={MessageType.INFO}>
      <Translation>pudo.not.supported</Translation>
    </Message>
  );
  
  return (
    <CheckoutOverlay
      autosize
      nopadding
      exitCallback={props.hidePudoCollectionPoints}
      title="pudo.addCollectionPoint"
    >
      {shouldNotLoadPUDO ? (
        getInfoMessage()
      ) : (
        <PudoNewCollectionPointLazyLoader />
      )}
    </CheckoutOverlay>
  );
}

PudoOverlay.propTypes = {
  hidePudoCollectionPoints: PropTypes.func.isRequired,
};

export default connect(null, {hidePudoCollectionPoints})(PudoOverlay);
